import { Grid, makeStyles } from "@material-ui/core";
import React from "react";
import { useParams } from "react-router-dom";
import { OrganisationHeader } from "../common/OrganisationHeader";
import { OrganisationViewDetails } from "./OrganisationViewDetails";
import { Skeleton } from "@material-ui/lab";
import { OrganisationAppBar } from "../OrganisationAppBar";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { UserRole } from "../../domain/userRole";
import { OrganisationRecognitionDetails } from "./OrganisationRecognitionDetails";
import { Helmet } from "react-helmet";
import { useOrganisationState } from "../../hooks/useOrganisationState";
import { OrgScrollableAreaTabs } from "../ActivityFeed/OrgScrollableAreaTabs";
import { NavigatingTabs } from "../common/NavigatingTabs";
import { ExpansionApplicationsList } from "../ExpansionApplicationsList/ExpansionApplicationsList";
import { OrganisationScopes } from "./OrganisationScopes";
import { UserType } from "../../redux/state";
import { authSelector } from "../../redux/selectors";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      marginTop: theme.contentOffsets.AFTER_RECORD_HEADER,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "25px", // theme.contentOffsets.AFTER_MAIN_APPBAR
    },
  },
}));

export const OrganisationView: React.FC = () => {
  const classes = useStyles();

  const { itemId } = useParams<{ itemId: string }>();

  const orgState = useOrganisationState(itemId);
  const { isInRole, userType } = useAuth(authSelector);

  const shouldSeeRecognitionTab = userType === UserType.Magic || isInRole(
    UserRole.ITAdmin,
    UserRole.OfqualRecognitionAdmin,
    UserRole.OfqualRecognitionUser
  );

  const shouldSeeExpansionApplicationTab =
    (userType === UserType.Magic || isInRole(
        UserRole.ITAdmin,
        UserRole.AOAdmin,
        UserRole.AoResponsibleOfficer,
        UserRole.AORegulationTeam,
        UserRole.OfqualRecognitionExpansionAdmin,
        UserRole.OfqualRecognitionExpansionReader
      )) && !orgState?.org.pendingRecognition

  const isPrendingRecognition = orgState?.org.pendingRecognition;
  //Rec Admin/Rec User/IT Admin
  //const canShowActivityFeed = isInRole(UserRole.OfqualRecognitionAdmin, UserRole.OfqualRecognitionUser, UserRole.ITAdmin);
  return (
    <div className={classes.root}>
      <Helmet>
        <title>The Portal - Organisations</title>
      </Helmet>
      <OrganisationAppBar breadcrumbs={[{ label: "" }]} />

      <OrganisationHeader organisationState={orgState} />

      <Grid container spacing={3}>
        <Grid item lg={8} xs={12}>
          {orgState ? (
            <NavigatingTabs
              dataTest="orgs-main-tabs"
              tabs={[
                {
                  id: "",
                  label: "Details",
                  content: <OrganisationViewDetails orgState={orgState} />,
                },
                shouldSeeRecognitionTab && {
                  id: "recognition",
                  label: "Recognition",
                  content: (
                    <OrganisationRecognitionDetails orgState={orgState} />
                  ),
                },
                shouldSeeExpansionApplicationTab && {
                  id: "scope",
                  label: "Scope Applications",
                  content: <ExpansionApplicationsList />,
                },
                !isPrendingRecognition && {
                  id: "scope-recognition",
                  label: "Scope of recognition",
                  content: <OrganisationScopes orgState={orgState} />,
                },
              ]}
            />
          ) : (
            <>
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <br />
              <Skeleton variant="rect" height={118} />
            </>
          )}
        </Grid>

        {
          <Grid item lg={4} xs={12}>
            <OrgScrollableAreaTabs
              orgState={orgState}
              isOfqualUser={userType === UserType.Ofqual}
            />
          </Grid>
        }
      </Grid>
    </div>
  );
};
